import React from 'react';

import SelectList from '../shared/inputs/SelectList';
import Dropdown from 'react-bootstrap/Dropdown';
import permissionsProvider from '../../utilities/permissionsProvider.js';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div style={{ width: '250px', display: 'flex', flexDirection: 'row-reverse' }}>
    <div className="text-nowrap drop-button user-control-button"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        </div>
    </div>
));

const UserControl = () => {

    return (
        <React.Fragment>
            {permissionsProvider.isMinUser('User') &&
                <Dropdown>
                    <Dropdown.Toggle as={CustomToggle} >
                        <span>Hello,</span> {window.biztrax.userName} <span className="down-arrow"></span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="user-control-drop" align='right'>
                        {permissionsProvider.isMinUser('Administrator') &&
                            <div className="text-nowrap">
                                <a href="/users/index">Admin</a>
                            </div>
                        }
                        <div className="text-nowrap">
                            <a href="/account/logout">Log Out</a>
                        </div>
                        <div className="text-nowrap">
                            <a href="/account/changepassword">Change Password</a>
                        </div>
                        {permissionsProvider.isMinUser('GlobalAdministrator') &&
                            <form className='pt-2' action='/account/impersonateFranchise' method='post' id='impersonate-form'>
                                <SelectList
                                    name='franchiseId'
                                    lookupType='franchise'
                                    value={window.biztrax.franchiseId}
                                    onChange={() => document.getElementById('impersonate-form').submit()}
                                />
                                <input type='hidden' name='returnUrl' value={window.location}></input>
                            </form>
                        }
                    </Dropdown.Menu>
                </Dropdown>
            }
        </React.Fragment>
    );
}

export default UserControl;